module.exports = __webpack_public_path__ + "img/key.77c7865.svg";